import * as React from "react"
import * as styles from '../sass/pages/volunteer.module.scss';
import Seo from "../components/seo"
import Layout from "../components/layout"
// import { StaticImage } from "gatsby-plugin-image";
// import { Link } from "gatsby";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faSquareFacebook, faLinkedin  } from '@fortawesome/free-brands-svg-icons';
import { StaticImage } from "gatsby-plugin-image";
import ContactForm from "../components/contact-form";


const Contact = () => {

  return (
    <Layout>
      <section className={`banner ${styles.pageHero}`}>
        <div className={styles.heroContent}>

          <h1>Get Involved</h1>
          
        </div>
        <StaticImage src="../images/volunteer-hero.jpg" alt="" placeholder="blurred" loading="eager" layout="fullWidth" className={styles.heroBackgroundImage} />
        <div className={styles.bannerOverlay} />
      </section>
      <section className={styles.contactContainer}>
        <div className="container small">

          <p>Whether you have a question, want to volunteer, or are ready to support the campaign, we’d love to hear from you! Join Team Sergio and be part of the movement for real change.</p>

          <br />
        
          <ContactForm />

        </div>
      </section>
    </Layout>
  )
}

export default Contact

export function Head({location}) {
  return (
    <>
      <Seo title="Get Involved: Volunteer" pathname={location.pathname}  />
      <body className={styles.contactPage} />
    </>
  )
}